import { useSelector, shallowEqual } from 'react-redux';

import { selectIsDualRate } from 'state/quote/quote-slice';

import { useMeterType } from './useMeterType';
import { useIsEVQuote } from './useIsEVQuote';

export const useElecMultirate = () => {
  const { isEVBeforeQuote } = useIsEVQuote();
  const { hasE7Meter } = useMeterType();
  const choseDualRateE7 = useSelector(selectIsDualRate, shallowEqual);

  const showE7Tariffs = !!(hasE7Meter && choseDualRateE7);

  return {
    showTOUTariffs: isEVBeforeQuote,
    showE7Tariffs
  };
};
